/*
  Project: For The People
  Author: Marcin Ziółek
 */

import filter from './modules/filter';
import lazyImg from './modules/lazy-img';
import map from './modules/map';
import mapSelect from './modules/map-select';
import modal from './modules/modal';
import nav from './modules/nav';
import progressRing from './modules/progress-ring';
import tabs from './modules/tabs';

map();
lazyImg();
tabs();
modal();
progressRing();
filter();
nav();
mapSelect();



// WEBPACK FOOTER //
// ./src/scripts/app.js